import { Component, Optional, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { NxiConfigUtil } from '@pershing/nxi-ng-common';
import { PershingTranslationService } from '@pershing/pershing-core';
import { PortalComponentService } from '../services/portal-component.service';

@Component({
    selector: 'modern-theme-footer',
    templateUrl: 'modern-theme-footer.component.html'
})

export class ModernThemeFooterComponent {
    community: string;
    isUserInNativeApp: boolean = false;
    siteSpecificPrimHasContent: boolean = true;
    isGeneric: boolean = false;
    isAdaThemeEnable: boolean = true;
    loginUrl: string = '/nxi/welcome';
    isLoggedIn: boolean = false;
    userFromMyClientView: boolean = false;
    overrideFdicDisclosure: boolean = false;
    adaUrl: string = '/nxi/communications/settings/default-settings';
    constructor(private router: Router, private translationService: PershingTranslationService, private adaThemeSettingService: PortalComponentService, @Optional() @Inject('AppSettings') appSettings: any) {
        this.translationService.addTranslationFolder('@pershing/nxi-portalcomponents', 'node_modules/@pershing/nxi-portalcomponents/lib');

        this.community = NxiConfigUtil.getCommunityName(appSettings);
            
        if (!!appSettings && !!appSettings.isUserInNativeApp) {
            this.isUserInNativeApp = true;
        }
        if (this.community === 'netxinvestor') {
            this.isGeneric = true;
        }
        this.isLoggedIn = appSettings.isLoggedIn;
        this.userFromMyClientView = !!appSettings.isAdvisor ? appSettings.isAdvisor : false;
    
        // exetertrustcompany alone needs separate disclosure - because they are BANK - not custodied under Pershing.
 
        if (appSettings?.ibdConfigMap?.community === 'exetertrustcompany' || appSettings?.ibdConfigMap?.community === 'texascapitaltrust') {
        this.overrideFdicDisclosure = true;
        }
    }
    checkContent(data: any) {
        this.siteSpecificPrimHasContent = data && !!data.articleId && data.articleId === 'site_specific_footer_primary' && data.hasContent;
    }
    handleDisclosure(): void {
        location.href = 'nxi/disclosure/brokeragedisclosure';
          }
    navigateToLocHref(url:string)
    {
        location.href = url;
           
    }
}



